import { ChoiceType, Field, FormFieldType, RadioSelectField } from 'scripts/type'

const isRadioButtonHasOtherChoice = (field: RadioSelectField) => {
  return field.choices?.some((c) => {
    return c.type === ChoiceType.OtherChoice
  })
}

const isDisplableField = (field: Field) => {
  return [FormFieldType.DescriptionField].includes(field.type as FormFieldType)
}
export const isDirectSubmittable = (fields: Field[]) => {
  if (fields.length === 1) return true
  if (fields.some((field) => field.showRules?.length)) return false

  const radioSelectableFieldsWithoutOtherChoice: Field[] = fields.filter((field) => {
    return (
      [FormFieldType.CesField, FormFieldType.CsatField, FormFieldType.RatingField, FormFieldType.NpsField].includes(
        field.type as FormFieldType
      ) ||
      ((field.type as FormFieldType) === FormFieldType.RadioButton &&
        !isRadioButtonHasOtherChoice(field as RadioSelectField))
    )
  })

  return (
    radioSelectableFieldsWithoutOtherChoice.length === 1 &&
    fields
      .filter((field) => field.code !== radioSelectableFieldsWithoutOtherChoice[0].code)
      .every((field) => isDisplableField(field))
  )
}
